import Bold from '@tiptap/extension-bold'
import Heading, { type Level } from '@tiptap/extension-heading'
import Italic from '@tiptap/extension-italic'
import { ListKit } from '@tiptap/extension-list'
import Placeholder from '@tiptap/extension-placeholder'
import Strike from '@tiptap/extension-strike'
import TextAlign from '@tiptap/extension-text-align'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'

export const defaultHeadingLevels: Level[] = [1, 2, 3, 4]

type GetExtensionKitProps = {
  headingLevels?: Level[]
  placeholder?: string
}

export const getExtensionKit = ({
  headingLevels = defaultHeadingLevels,
  placeholder,
}: GetExtensionKitProps) => [
  StarterKit.configure({
    bold: false,
    bulletList: false,
    heading: false,
    italic: false,
    listItem: false,
    listKeymap: false,
    orderedList: false,
    strike: false,
    underline: false,
  }),
  Bold,
  Italic,
  Underline,
  Strike,
  ListKit.configure({
    taskList: false,
  }),
  Heading.configure({
    levels: Array.from(headingLevels),
  }),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  Placeholder.configure({
    placeholder,
  }),
]
